import { render } from "./ResourceOverlay.vue?vue&type=template&id=3e3a5a8a"
import script from "./ResourceOverlay.vue?vue&type=script&lang=js"
export * from "./ResourceOverlay.vue?vue&type=script&lang=js"

import "./ResourceOverlay.vue?vue&type=style&index=0&id=3e3a5a8a&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__